<template>
  <div class="main">
    <ball></ball>
    <div class="nav">
      <!-- <Nav :title="'费用列表'" :fixed="true"> </Nav> -->
       <div class="nav">
      <van-nav-bar
        title="费用列表"
        left-arrow
        :fixed=flexfalg
        @click-left="onClickLeft"
      />
      <div class="top"></div>
       </div>
        
    </div>
  
    <div v-if="emptyflag">
      <van-empty image="https://account.kmmds.top/datainfo_pic/error.png" description="暂无缴费信息" />
    </div>
    
    <van-collapse v-model="activeNames" v-else >
      <van-collapse-item
        v-for="(item, key1, index) in clinicIdInfo"
        :name="key1"
        :key="index"
      >
        <template #title>
          <div class="coll_title" @click.stop>
            <div>流水号: {{ key1 }}</div>
            <!-- <van-checkbox
              v-model="clinicIdInfo_checkeds[index]"
              @click ="allcheck(key1, index)"
              >全选</van-checkbox
            > -->
          </div>
        </template>
        <!-- <div class="radio">
          <div class="radio_title">全选</div>
          <div class="checkbox2">
            <van-checkbox
              v-model="checked"
              @click.stop="allcheck(item)"
            ></van-checkbox>
          </div>
        </div> -->
        <div
          class="paycard"
          v-for="(item2, index1) in clinicIdInfo[key1]"
          :key="index1"
        >
          <div class="head">
            <div>处方费</div>
            <div class="checkbox">
              <van-checkbox
                ref="checkitem"
                :name="index1"
                v-model="item2.checked"
                @click="gettotalPice(item2, key1, index)"
              ></van-checkbox>
            </div>
          </div>
          <div>
            <div class="Crow">
              <div>就诊人</div>
              <div>{{ item2.clientName }}</div>
            </div>
            <div class="Crow">
              <div>处方号:{{ item2.recipeId }}</div>
              <div class="gold">未缴费</div>
            </div>
            <!-- <div class="Crow">
              <div>{{ item2.feeTypeName }}参考费</div>
              <div class="gold">￥{{ item2.recipeFee }}</div>
            </div> -->
            <div class="Crow">
              <div>{{ item2.regDeptName }}</div>
              <div>{{ item2.regDate }}</div>
            </div>
          </div>
        </div>
      </van-collapse-item>
    </van-collapse>
    <div class="last_item"></div>
    <div class="pay_list_foot" v-if="!emptyflag">
      <!-- <van-checkbox v-model="checked" @click="allcheck">全选</van-checkbox> -->
      <div class="pay_button" @click="gosettlement">结算</div>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/nav.vue";
import setOptions from "@/mixins/setOption";
import backindex from '@/mixins/backindex'
export default {
  mixins: [setOptions,backindex],
  data() {
    return {
      flexfalg:true,
      emptyflag: false,
      testcheck: null,
      TotalPrice: 0,
      activeNames: [],
      result: [],
      clinicIdInfo_checkeds: [],
      key: null,
      clientId: null,
      name: null,
      clinicIdInfo: {},
      recipeIdArr: [],
      //挂号流水号
      registerId: "",
      paywaylist:null,
    };
  },
  components: {
    Nav,
  },
  mounted() {
 if (this.$route.query) {
      this.clientId = this.$route.query.clientId;
    }
    if (!this.clientId || this.clientId == "") {
      // this.Dialog();
      this.goconfUser()
      return;
    }
    this.getPayList();
    this.getPayWay()
   
  },
  methods: {
   async getPayWay() {
      try {
        this.$showLoad();
        let url = "/hospitalconf/index/getPayType";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          null,
          (data) => {
            this.$hideLoad();
            this.paywaylist = data.data.objType[0].paykey;
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }
    },
    onClickLeft(){
       
      this.$router.push('/index');
    },
    //预结算
     gosettlement() {
        let recipeIdarr = [];
        this.clinicIdInfo[this.key].forEach(element => {
          if(element.checked){
            recipeIdarr.push(element.recipeId);
          }
        });
        // console.log(this.key)
        if(recipeIdarr.length===0){
          this.$toast.fail("未选择处方")
          return
        }
       this.$router.push({path:'/ODpay_order_detail_C',query:{
          registerId:this.key,
          recipeId:JSON.stringify(recipeIdarr),
          clientId:this.clientId,
         payWay:this.paywaylist
       }})
    },
    //提示
    Dialog() {
      // console.log(123)
      this.$dialog
        .confirm({
          message: "请选择就诊人信息",
        })
        .then(() => {
          this.goconfUser();
        })
        .catch(() => {
          // on cancel
          this.$router.push("/index");
        });
    },
    //获取缴费列表
    async getPayList() {
      try {
        this.$showLoad();
        // this.isLoad = true
        let url = "/outpatientfee/querychargedrecipe";
        let medCardNo = this.clientId;
        let R_data = {
          medCardNo: medCardNo,
        };
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          R_data,
          (data) => {
            this.clinicIdInfo = data.data.data;
            // this.clinicIdInfo["112817"] = data.data["112816"];
            let bool = true;
            let first_key = null;
            for (let key in this.clinicIdInfo) {
              this.activeNames.push(key);
              if (bool) {
                first_key = key;
                this.clinicIdInfo_checkeds.push(true);
              } else {
                this.clinicIdInfo_checkeds.push(false);
              }
              bool = false;
              // console.log(this.clinicIdInfo_checkeds);
            }
            if (Object.keys(this.clinicIdInfo) == 0) {
              this.emptyflag = true;
              this.$hideLoad();
              return;
            }
            this.allcheck(first_key, 0);

            this.$hideLoad();
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }
    },
    //go选择用户
    goconfUser() {
      this.$router.push("/patient_card_confUser_C");
    },
    //全选
   //全选
    allcheck(key, index) {
      // console.log("全选值",this.clinicIdInfo_checkeds[index]);
      this.key = key;
      if (this.clinicIdInfo_checkeds[index]) {
        for (let i = 0; i < this.clinicIdInfo_checkeds.length; i++) {
          if (i != index) {
            this.clinicIdInfo_checkeds[i] = false;
          }
        }
      }
      this.checkedconfirm("all");
    },
    //单选
    gettotalPice(item, key, index) {
      //item为每个流水号下的对象
      //根据每个item的状态来对总金额和门诊缴费操作
      //为true添加，False减去
      // console.log(item);
      // console.log(key);
      if (item.checked) {
        this.key = key;
      }
      this.checkedconfirm("one");
      // console.log("看下下标完成",index);
      // console.log(this.clinicIdInfo_checkeds);
      let recipeIdarr = [];
        this.clinicIdInfo[this.key].forEach(element => {
          if(element.checked){
            recipeIdarr.push(element.recipeId);
          }
        });
        // console.log("看下下标完成",index);
        // console.log(this.clinicIdInfo_checkeds);
        // console.log(recipeIdarr);
    },
    checkedconfirm(source) {
      let price = 0;
      let key_index = 0;
      for (let key in this.clinicIdInfo) {
        if (this.key != key) {
          this.clinicIdInfo_checkeds[key_index] = false;
        }
        let start_bool = true;
        for (let i = 0; i < this.clinicIdInfo[key].length; i++) {
          if (source == "all" && !this.clinicIdInfo_checkeds[key_index]) {
            this.clinicIdInfo[key][i].checked = false;
          } else if (source == "one") {
            if (this.key == key) {
              if (!this.clinicIdInfo[key][i].checked) {
                start_bool = false;
              } else {
                // start_bool = true;
                // 计算价格
                price += Number(this.clinicIdInfo[key][i].recipeFee);
              }
            } else {
              this.clinicIdInfo[key][i].checked = false;
            }
          } else {
            if (source == "all") {
              if (this.clinicIdInfo_checkeds[key_index]) {
                this.clinicIdInfo[key][i].checked = true;
                price += Number(this.clinicIdInfo[key][i].recipeFee);
              }
            }
          }
        }
        if (source == "one"&&this.key==key) {
          this.clinicIdInfo_checkeds[key_index] = start_bool;
          // console.log("看下下标单选",key_index);
      console.log(this.clinicIdInfo_checkeds[key_index]);
        }
        key_index += 1;
      }
      this.TotalPrice = price;
      // this.checked = true;
      // this.TotalPrice = 0;
      // for (let key in this.clinicIdInfo) {
      //   //true几个执行几次
      //   this.clinicIdInfo[key].forEach((element) => {
      //     if (element.checked) {
      //       this.TotalPrice += Number(element.recipeFee);
      //       // this.recipeIdArr.push(element.recipeId);
      //       console.log(this.recipeIdArr);
      //     } else {
      //       // this.recipeIdArr.pop(element.recipeId);
      //       this.checked = false;
      //     }
      //   });
      // }
    },
  },
};
</script>

<style lang="scss" scoped>

.main {
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  .top{
  height: 50px;
}
  .paycard {
    padding: 5px;
    width: 100%;
    display: flex;
    flex-direction: column;
    // border: 1px solid #5b8df6;
    border-radius: 15px;
    margin: 0px auto;
    margin-top: 3px;
    margin-bottom: 15px;
    box-shadow: 0 1px 3px #5b8df6;
  }
  .head {
    margin-left: 10px;
    margin-right: 10px;
    color: #5b8df6;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px dashed #5b8df6;
    font-size: 16px;
    line-height: 30px;
    .checkbox {
      margin-top: 5px;
    }
  }
  .content {
    width: 90%;
    display: flex;
    flex-direction: column;
    border: 1px solid #95a5a6;
    border-radius: 15px;
    margin: 0px auto;
  }
  .Crow {
    color: #747d8c;
    margin-left: 20px;
    margin-right: 20px;
    line-height: 30px;
    display: flex;
    font-size: 15px;
    justify-content: space-between;
    .gold {
      color: #e74c3c;
    }
    .green {
      color: #2ed573;
    }
  }
  .line {
    border-bottom: 1px solid #95a5a6;
  }
  // .btn {
  //   display: flex;
  //   flex-direction: row;
  //   padding: 5px;
  //   margin-top: 5px;
  //   .paybtn {
  //     height: 35px;
  //     line-height: 35px;
  //     text-align: center;
  //     letter-spacing: 10px;
  //     font-size: 15px;
  //     margin: 0px auto;
  //     color: #eeeeee;
  //     border: 1px solid #f4f4f4;
  //     background-color: #5b8df6;
  //     border-radius: 10px;
  //     width: 80%;
  //   }
  // }
}
.pay_list_foot {
  width: 100%;
  background-color: white;
  position: fixed;
  bottom: 0;
  border-top: 1px solid #aaaaaaaa;
  height: 60px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  line-height: 70px;
  .pay_text {
    margin-left: 20px;
    color: #aaaaaa;
    .money {
      color: #e74c3c;
    }
  }
  .pay_button {
    background-color: #5b8df6;
    margin-right: 20px;
    width: 90%;
    margin: 0px auto;
    height: 40px;
    line-height: 40px;
    border-radius: 5px;
    color: #ffffff;
  }
}
.last_item {
  height: 1px;
  margin-bottom: 70px;
}
.coll_title {
  color: #747d8c;
  display: flex;
  justify-content: space-between;
  width: 95%;
}
.radio {
  padding: 5px;
  width: 100%;
  box-shadow: 0 1px 3px #5b8df6;
  border-radius: 8px;
  color: #747d8c;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #f7f8fa;
  font-size: 16px;
  line-height: 30px;
  .radio_title {
    margin-left: 5px;
  }
  .checkbox2 {
    margin-top: 5px;
    margin-right: 10px;
  }
  margin-bottom: 8px;
}
.van-cell {
  font-size: 18px;
}
</style>